import { CategoryColor } from '@models/TagCategory.model';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #161a30;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

interface IInputSearch {
  search?: boolean;
  clear?: boolean;
}

export const InputSearch = styled.input<IInputSearch>`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  &::placeholder {
    color: #8f95b2;
  }

  ${({ search }) =>
    search &&
    css`
      padding-right: 66px;
    `}
  ${({ clear }) =>
    clear &&
    css`
      padding-right: 36px;
    `}
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  &.manage {
    gap: 8px;
  }
`;

interface IButton {
  disabled?: boolean;
}

export const Button = styled.button<IButton>`
  display: flex;
  flex-direction: row;
  height: 42px;
  padding: 10px 16px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  background-color: transparent;
  color: #474d66;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: 14px;
  font-weight: 500;

  margin-left: 8px;

  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};

  :disabled {
    background-color: #edeff4;
    color: #c1c4d6;
  }

  &.addButton {
    padding: 0px;
  }
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
`;

export const IconContainer = styled.div`
  display: flex;
  padding-top: 6px;
`;

export const Spacing = styled.div`
  margin: 0 40px;
  margin-bottom: 8px;
  align-items: center;
`;

export const HeaderWrapper = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
`;

export const LineDivider = styled.div`
  width: 100%;
  background: #e6e8f0;
  height: 1px;
`;

export const Header = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 3fr 6fr 2fr 2fr 60px;
  grid-column-gap: 24px;
`;

export const Direction = styled.div`
  margin-left: 8px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

export const ColumnName = styled.div`
  font-size: 12px;
  color: #8f95b2;
  font-weight: 500;
`;

interface IItem {
  grid: boolean;
}

export const Item = styled.div<IItem>`
  display: grid;
  flex-direction: row;
  width: 100%;
  grid-template-columns: ${({ grid }) =>
    grid ? '38px 3fr 6fr 2fr 2fr 60px' : '3fr 6fr 2fr 2fr 60px'};
  grid-column-gap: 24px;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  margin-top: 16px;
  cursor: pointer;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IColor {
  color?: CategoryColor;
}

export const Color = styled.div<IColor>`
  display: flex;
  align-self: center;
  width: 100%;
  max-width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: ${({ color }) => color || '#edeff4'};
  margin: 0 24px;
`;

interface IText {
  light?: boolean;
  limitOfLines?: number;
}

export const Text = styled.div<IText>`
  font-size: 14px;
  font-weight: ${({ light }) => (light ? '400' : '500')};
  color: ${({ light }) => (light ? '#474d66' : '#1b203a')};

  &.subText {
    font-weight: 400;
    font-size: 12px;
    color: #8f95b2;
  }

  &.noDescription {
    font-weight: 400;
    font-size: 12px;
    color: #8f95b2;
    font-style: italic;
    margin-bottom: -3px;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const ChevronDiv = styled.div`
  display: flex;
`;

export const TagWrapper = styled.div`
  margin-left: 37px;
`;

interface IActionButtons {
  background: string;
}

export const ActionButtons = styled.button<IActionButtons>`
  display: flex;
  height: 42px;
  padding: 10px 16px;
  color: #fff;
  background-color: ${({ background }) => background || '#1371fe'};
  border-radius: 8px;
  border: 0;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: 500;
`;

interface ICheckBox {
  checked?: boolean;
}

export const Checkbox = styled.div<ICheckBox>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid ${({ checked }) => (checked ? '#1371fe' : '#d8dae5')};
  background-color: ${({ checked }) => (checked ? '#1371fe' : 'transparent')};
  margin-right: 24px;
  cursor: pointer;
`;

export const ToolTipDiv = styled.div`
  display: flex;
`;

export const MenuDiv = styled.div`
  display: flex;
  align-self: flex-end;
`;

export const Table = styled.div`
  height: 100%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Close = styled.img`
  cursor: pointer;
  margin-left: -30px;
  margin-right: 9px;
  height: 20px;
  width: 20px;
  padding: 2px;
  border-radius: 4px;
  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;
